var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      display: "block"
    },
    width: "101px",
    height: "101px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 66.66,
    cy: 62.784,
    fill: "#93dbe9",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 62.784,
    cy: 66.66,
    fill: "#689cc5",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.062s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 58.036,
    cy: 69.401,
    fill: "#5e6fa3",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.125s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 52.741,
    cy: 70.82,
    fill: "#3b4368",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.187s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 47.259,
    cy: 70.82,
    fill: "#191d3a",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.25s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 41.964,
    cy: 69.401,
    fill: "#d9dbee",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.312s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 37.216,
    cy: 66.66,
    fill: "#b3b7e2",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.375s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33.34,
    cy: 62.784,
    fill: "#93dbe9",
    r: 4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;360 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s",
    begin: "-0.437s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "spline",
    values: "0 50 50;0 50 50",
    times: "0;1",
    keySplines: "0.5 0 0.5 1",
    repeatCount: "indefinite",
    dur: "1.4925373134328357s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media_static/loader.32346f5325e70e83c289d45c56d1bee8.svg";
export { ForwardRef as ReactComponent };